import { render } from "./MedicarePayer.vue?vue&type=template&id=71862074&ts=true"
import script from "./MedicarePayer.vue?vue&type=script&lang=ts"
export * from "./MedicarePayer.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__